import type ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import { getExtendedPropertyUri } from 'owa-service/lib/ServiceRequestUtils';

/** Extended property that contains the Copilot generated Importance Score details */
export const CalendarAITimeInsightsExtendedProperty: ExtendedPropertyUri = getExtendedPropertyUri(
    '00062002-0000-0000-C000-000000000046',
    'CalendarAITimeInsights',
    'String'
);
